import versions from '../../../config/browser_cache_versions.json';

// Bump only the affected entry when a browser cache's schema or ownership changes.
// Rails reads the same manifest through BrowserCacheVersions.
export const browserCacheVersions = Object.freeze(versions);
